import { Injectable } from '@angular/core'
import { Product } from '../../product/product'
import { CategoryMapping, TargetGroup } from '../../../shared/models'
import { PaginatedResponse } from 'src/app/shared/interfaces'
import { HttpClient } from '@angular/common/http'
import { ProductSerializer } from '../../product/product.serializer'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { Observable } from 'rxjs'
import { buildHttpParams } from '../../../shared/query-utils'
import { environment } from 'src/environments/environment'
import { map } from 'rxjs/operators'
import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms'
import { ParticipationService } from '../../booking/participation/participation.service'
@Injectable({
  providedIn: 'root'
})
export class BookingMultiDayService {
  constructor(
    private http: HttpClient,
    private productSerializer: ProductSerializer,
    private store: Store<AppState>,
    public participationService: ParticipationService
  ) {}
  public getProductPrice(
    product: Partial<Product>,
    targetGroup: TargetGroup
  ): number {
    const targetGroupId = CategoryMapping[targetGroup]
    let price: number | string = product.price
    return Number(product?.[`category${targetGroupId}Price`])
  }
  public getManyProducts(params?: RequestQueryBuilder): Observable<Product[]> {
    return this.http
      .get<PaginatedResponse>(`${environment.backendApiUrl}/products`, {
        params: buildHttpParams(params)
      })
      .pipe(
        map((reponse) =>
          reponse.data.map(
            (data: any) => this.productSerializer.fromJson(data) as Product
          )
        )
      )
  }
  public calculateProductFormArray(
    productEntities,
    product,
    bookings,
    objectPrioritary,
    participantsToFill
  ) {
    let maxPart: any = product.parentBookableProducts
      .map((p) =>
        typeof p == 'number'
          ? this.participationService.calculateParticipantLimits(
              productEntities[p],
              null,
              null
            ).maxParticipants
          : this.participationService.calculateParticipantLimits(
              productEntities[p.productId],
              null,
              null
            ).maxParticipants
      )
      .reduce((a, b) => a + b, 0)
    bookings.forEach((booking) => {
      if (
        product.parentBookableProducts.includes(booking?.linkedProductId) ||
        product.parentBookableProducts.includes(booking?.productId) ||
        product?.id == booking?.linkedProductId
      ) {
        maxPart -= booking.currentParticipantCount
          ? booking.currentParticipantCount
          : booking?.participations?.length
          ? booking?.participations?.length
          : maxPart
      }
    })
    if (objectPrioritary.id === product.id) {
      return {
        productId: [product.id],
        bookableProductId: [product.parentBookableProducts[0]],
        qty: [1],
        persons: [
          participantsToFill,
          [Validators.required, Validators.min(0), Validators.max(maxPart)]
        ],
        maxResourceParticipants: [maxPart]
      }
    } else {
      return {
        productId: [product.id],
        bookableProductId: [product.parentBookableProducts[0]],
        qty: [1],
        persons: [
          0,
          [Validators.required, Validators.min(0), Validators.max(maxPart)]
        ],
        maxResourceParticipants: [maxPart]
      }
    }
  }
}
